import { getOperation, fetchOperation, putOperation } from "utils/api";

export const queryEmployee = async (params) => {
  return await getOperation("/employee/list", {
    sort: "createdDate,desc",
    ...params,
  });
};
export const updateStatus = async (params) => {
  return await putOperation("/employee/detail", {
    ...params,
  });
};

export const changePassword = async (params) => {
  return await fetchOperation("/admin/reset/password", {
    ...params,
  });
};

export const getSuspensionRemarks = async () => {
  return await getOperation("/account-management/remarks");
};
